@import 'styles/mixins';
@import 'styles/variables';

.backdrop {
  align-items: center;
  background-color: change-color($gray-90, $alpha: 0.25);
  display: flex;
  justify-content: center;
  position: fixed;
  bottom: 0;
  left: 0;
  top: 0;
  right: 0;
  z-index: z-index('overlay');

  &.animated {
    @include fadein;
  }
}

.modal {
  @include shadow-3;

  background-color: $white;
  border-radius: 8px;
  min-width: 560px;

  @include for-phone-only {
    min-width: 320px;
    max-width: calc(100% - 20px);
  }

  > header {
    @include header-md;

    align-items: center;
    color: $almanac-black;
    border-bottom: 2px solid $gray-5;
    display: flex;
    padding: 16px 24px;

    .closeButton {
      margin-left: auto;

      svg {
        fill: currentColor;
        vertical-align: middle;
      }
    }
  }

  .modalBody {
    padding: 16px 24px;
  }

  .footerDivider {
    border: 0;
    border-top: 2px solid $gray-5;
    margin: 0 -24px 16px -24px;
  }
}
.withGradient {
  box-shadow: 0px 6px 6px rgba(135, 84, 186, 0.05), 0px 4px 6px rgba(135, 84, 186, 0.08),
    0px 2px 2px rgba(135, 84, 186, 0.1), 0px 10px 10px rgba(238, 130, 96, 0.1), 2px -1px 12px rgba(255, 216, 116, 0.4),
    6px 12px 24px rgba(217, 155, 255, 0.3);
}
